import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import heroVideo from '../assets/video/hero.mp4';

const demoVideoUrl = 'https://www.youtube.com/embed/mj5ZGNk9b1Y?autoplay=1&rel=0';

const Hero = () => {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  useEffect(() => {
    if (!isDemoOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsDemoOpen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isDemoOpen]);

  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <Badge className="hero-badge">
            <div className="badge-dot"></div>
            AI-Powered Communication Platform
          </Badge>
          
          <h1 className="hero-title">
            Boost Revenue Through{' '}
            <span className="gradient-text">Contextual</span>{' '}
            Communications
          </h1>
          
          <p className="hero-description">
            Streamline customer conversations — enhance engagement, boost efficiency, drive growth. 
            Convert high-intent visitors to paying customers via context-rich calls, texts, and emails with 50%+ ROI.
          </p>
          
          <div className="hero-ctas">
            <Button size="lg" asChild>
              <a href="https://sso.contexttocall.com/realms/c2cp1/protocol/openid-connect/registrations?client_id=c2c-biz-app&redirect_uri=https%3A%2F%2Fapp.contexttocall.com&response_type=code" target="_blank" rel="noopener noreferrer">
                Get Started Free <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </Button>
            <Button size="lg" variant="outline" type="button" onClick={() => setIsDemoOpen(true)}>
                Watch Demo
            </Button>
          </div>
          
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">112<span>+</span></div>
              <div className="stat-label">Countries Supported</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50<span>%+</span></div>
              <div className="stat-label">ROI Increase</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">30<span>+</span></div>
              <div className="stat-label">AI Languages</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">4</div>
              <div className="stat-label">Powerful Products</div>
            </div>
          </div>
        </div>
        
        <div className="hero-visual">
          <div className="hero-card">
            <div className="hero-animation" aria-label="Context to Call product video preview">
              <video src={heroVideo} autoPlay muted loop playsInline aria-label="Context to Call product video preview" />
            </div>
          </div>
        </div>
      </div>

      {isDemoOpen && (
        <div className="demo-modal" role="dialog" aria-modal="true" aria-label="Watch product demo">
          <button className="demo-modal-backdrop" type="button" aria-label="Close demo video" onClick={() => setIsDemoOpen(false)} />
          <div className="demo-modal-content">
            <button className="demo-modal-close" type="button" aria-label="Close demo video" onClick={() => setIsDemoOpen(false)}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <iframe
              src={demoVideoUrl}
              title="Context to Call demo video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;
